import React from 'react'
import { useState, useEffect } from 'react'
import { Sidebar } from '../../../components/Sidebar/Sidebar'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import axios from 'axios'
import { Baseurl } from '../../../../Config/Baseurl'
import { Link } from 'react-router-dom'

export const AddExam = () => {
  toast.configure()
  const [complexity, setComplexity] = useState()
  const [subjects, setSubjects] = useState()

  //array to store the subject and complexity based on
  //subject-question count/complexity-question count
  const [data, setData] = useState([])
  const [complex, setComplex] = useState([])
  const [sub, setSub] = useState('')
  const [cmpl, setCmpl] = useState('')

  // store the input values
  const [values, setValues] = useState({
    selectSubject: '',
    totalQues: '',
    totalMarks: '',
    passingMarks: '',
    duration: '',
    selectedSub: '',
    complexity: '',

    numberOfQues: '',
    numberOfComplexity: '',
  })

  // add subject and question count of selected subject
  const onclick = (e) => {
    e.preventDefault()

    setData((data) => [
      ...data,
      {
        sub_id: values.selectedSub,
        count: values.numberOfQues,
        sub_name: sub,
      },
    ])
  }

  // add complexity and question count of selected subject
  const onAdd = (e) => {
    e.preventDefault()

    setComplex((complex) => [
      ...complex,
      {
        complex_id: values.complexity,
        count: values.numberOfComplexity,
        complex_name: cmpl,
      },
    ])
  }

  // input onchange
  let name, value, selctedSub, selectedComplexity
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })

    if (name === 'selectedSub') {
      selctedSub = e.target.selectedOptions[0]
      setSub(selctedSub.text)
    }

    if (name === 'complexity') {
      selectedComplexity = e.target.selectedOptions[0]
      setCmpl(selectedComplexity.text)
    }
  }

  // to declare exam containing all the required data
  const declareExam = async (e) => {
    e.preventDefault()
    await axios
      .post(Baseurl.nodeLocal + 'exam/declareExam', {
        exam_name: values.selectSubject,
        tot_marks: values.totalMarks,
        passing_marks: values.passingMarks,
        duration: values.duration,
        total_que: values.totalQues,
        sub_que: data,
        complexity_level: complex,
      })
      .then((response) => {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        // on success clear the value of input data and count array
        setTimeout(() => {
          setValues({
            selectSubject: '',
            totalQues: '',
            totalMarks: '',
            passingMarks: '',
            duration: '',
            selectedSub: '',
            complexity: '',

            numberOfQues: '',
            numberOfComplexity: '',
          })
          setComplex('')
          setData('')
        }, 2000)
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
  }

  // to get complexity
  const getComplexity = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'question/fetchComplexity')
      .then((res) => {
        setComplexity(res.data.data)
      })
      .catch((error) => {})
  }

  // to get already declred subjects
  const getSubjects = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'subject/fetchAllSubjects')
      .then((res) => {
        setSubjects(res.data.data)
      })
      .catch((error) => {})
  }

  useEffect(() => {
    getComplexity()
    getSubjects()
  }, [])

  return (
    <div className=" row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="col-md-10 mt-4 p-4 d-flex justify-content-center align-items-center flex-column">
        {/* breadcrumbs */}
        <div className="d-flex justify-contetn-center">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/examdashboard" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item" aria-current="page">
                <Link to="/viewexams" className="link text-primary">
                  View Exams
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Add Exam
              </li>
            </ol>
          </nav>
        </div>
        <div className="card w-75">
          {/* add exam card to declare exam with required details */}
          <div className="card-header">
            <div className="pt-4 pl-2 pr-2 pb-2">
              <ul className="nav bg-light nav-pills rounded nav-fill mb-3">
                <li className="nav-item">
                  <h4 className="mt-1"> Add New Exam</h4>
                </li>
              </ul>
            </div>
            <div className="tab-content">
              <div className="tab-pane fade show active pt-3">
                <form onSubmit={declareExam}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        {' '}
                        <label htmlFor="username">
                          <h6>Exam Title</h6>
                        </label>{' '}
                        <input
                          type="text"
                          className="form-control"
                          name="selectSubject"
                          onChange={handleChange}
                          value={values.selectSubject}
                          required
                        />
                        <div className="form-group mt-2">
                          <label htmlFor="cardNumber">
                            <h6>Exam Duration (in minutes)</h6>
                          </label>
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
                              name="duration"
                              onChange={handleChange}
                              value={values.duration}
                              step="0.0001"
                              required
                            />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-sm-4">
                            <label htmlFor="cardNumber">
                              <h6>Total Questions</h6>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="totalQues"
                              onChange={handleChange}
                              value={values.totalQues}
                              required
                            />
                          </div>
                          <div className="col-sm-4">
                            <label htmlFor="cardNumber">
                              <h6>Total Marks</h6>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="totalMarks"
                              onChange={handleChange}
                              value={values.totalMarks}
                              required
                            />
                          </div>
                          <div className="col-sm-4">
                            <label htmlFor="cardNumber">
                              <h6>Passing Marks</h6>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="passingMarks"
                              onChange={handleChange}
                              value={values.passingMarks}
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        {data.length > 0 ? (
                          <div className="col-md-6 text-primary">
                            Subject & Count
                            {data?.map((i) => {
                              return (
                                <div className="row text-secondary">
                                  <div className="col-md">{i.sub_name}</div>
                                  <div className="col-md">{i.count}</div>
                                </div>
                              )
                            })}
                          </div>
                        ) : (
                          ''
                        )}
                        {complex.length > 0 ? (
                          <div className="col-md-6 text-primary">
                            Complexity & Count
                            {complex?.map((i) => {
                              return (
                                <div className="row text-secondary">
                                  <div className="col-md">{i.complex_name}</div>
                                  <div className="col-md">{i.count}</div>
                                </div>
                              )
                            })}
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        {' '}
                        <label className="form-label">
                          <h6> Select Subject</h6>
                        </label>
                        <select
                          className="form-select form-control"
                          aria-label="Default select example"
                          name="selectedSub"
                          onChange={handleChange}
                          value={values.selectedSub}
                          style={{ marginTop: '-2%' }}
                          required
                        >
                          <option value="" selected disabled>
                            Select
                          </option>
                          {subjects?.map((i, index) => {
                            return (
                              <option value={i.sub_id} key={index}>
                                {i.name}
                              </option>
                            )
                          })}
                        </select>
                      </div>

                      <div className="row mt-2">
                        <div className="col-sm-10">
                          <label htmlFor="cardNumber">
                            <h6>Number Of Questions Of Selected Subject</h6>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="numberOfQues"
                            onChange={handleChange}
                            value={values.numberOfQues}
                            required
                          />
                        </div>
                        <div className="col-sm-2">
                          <button
                            className="btn btn-primary btn-sm"
                            style={{ marginTop: '2rem' }}
                            onClick={onclick}
                          >
                            Add
                          </button>
                        </div>
                      </div>

                      <div className="form-group mt-2">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label"
                        >
                          <h6> Select Complexity</h6>
                        </label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          name="complexity"
                          onChange={handleChange}
                          value={values.complexity}
                          style={{ marginTop: '-2%' }}
                          required
                        >
                          <option value="" selected disabled>
                            Select
                          </option>
                          {complexity?.map((i, index) => {
                            return (
                              <option value={i.c_id} key={index}>
                                {i.c_name}
                              </option>
                            )
                          })}
                        </select>
                      </div>
                      <div className="row" style={{ marginTop: '0.9rem' }}>
                        <div className="col-sm-10">
                          <label htmlFor="cardNumber">
                            <h6>Number Of Questions Of Selected Complexity</h6>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="numberOfComplexity"
                            onChange={handleChange}
                            value={values.numberOfComplexity}
                            required
                          />
                        </div>
                        <div className="col-sm-2">
                          <button
                            className="btn btn-primary btn-sm"
                            style={{ marginTop: '2rem' }}
                            onClick={onAdd}
                          >
                            Add
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-grid gap-2 mt-4 d-flex justify-content-center">
                    {' '}
                    <button type="submit" className=" btn btn-primary col-md-2">
                      {' '}
                      Confirm
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
